import { render } from "./ModalHomologa.vue?vue&type=template&id=cf86ace4&scoped=true"
import script from "./ModalHomologa.vue?vue&type=script&lang=js"
export * from "./ModalHomologa.vue?vue&type=script&lang=js"

import "./ModalHomologa.vue?vue&type=style&index=0&id=cf86ace4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf86ace4"]])

export default __exports__